import Cookies from "js-cookie";

export class SessionStartNotDefinedError extends Error {
    constructor() {
        super("Session start timestamp not defined.");
        this.name = "SessionStartNotDefinedError";
    }
}

export default new class BrowserSessionService {
    private static readonly CookieName = "_sbeg";

    constructor() {
        if (Cookies.get(BrowserSessionService.CookieName) === undefined) {
            Cookies.set(BrowserSessionService.CookieName, Date.now().toString());
        }
    }

    public getSessionStartTime(): Date {
        const sessionStartTimestamp = Cookies.get(BrowserSessionService.CookieName);

        if (sessionStartTimestamp === undefined) {
            throw new SessionStartNotDefinedError();
        }

        const sessionStartTime = new Date();

        sessionStartTime.setTime(Number.parseInt(sessionStartTimestamp));

        return sessionStartTime;
    }
}();
